import { getMediaGalleryEntries } from '@/util/getProductImage';
import { useMemo } from 'react';

export const useGetMediaGalleryEntries = ({ product, optionCodes, optionSelections }) => {
  const mediaGalleryEntries = useMemo(
    () => getMediaGalleryEntries(product, optionCodes, optionSelections),
    [product, optionCodes, optionSelections],
  );

  const galleryImages = useMemo(() => {
    const images = [];

    if (!mediaGalleryEntries) {
      return;
    }

    const mediaGalleryEntriesClone = mediaGalleryEntries
      .slice(0)
      .sort((a, b) => (a?.position || 0) - (b?.position || 0));

    mediaGalleryEntriesClone.forEach((item, index) => {
      images.push({
        file: item.url,
        label: item.label,
        thumbnail: mediaGalleryEntriesClone[index]?.url,
      });
    });

    return images;
  }, [mediaGalleryEntries]);

  return {
    mediaGalleryEntries,
    galleryImages,
  };
};
